export enum ModalTypeEnum {
	DEFAULT = 'DEFAULT',
	CUSTOM = 'CUSTOM',
	CONFIRM = 'CONFIRM',
	ERROR = 'ERROR',
}

export enum ModalSizeEnum {
	DEFAULT = 'DEFAULT',
	FULL_WIDTH = 'FULL_WIDTH',
	LARGE = 'LARGE',
	MEDIUM = 'MEDIUM',
	AUTO = 'AUTO',
}

export interface IModalContainer {
	isCustomType: boolean;
	ref?: React.MutableRefObject<undefined>;
	backgroundColor: string;
	size?: ModalSizeEnum;
	isLoading?: boolean;
}

export interface IModalHeader {
	withBackground: boolean;
}

export interface IModalContentContainer {
	withMargin: boolean;
	isCustomType: boolean;
	withTopbar: boolean;
	noButtons: boolean;
}

export interface IModal {
	title: string;
	isOpen: boolean;
	className?: string;
	backgroundColor?: string;
	closeOnClickOutside?: boolean;
	closable?: boolean;
	noButtons?: boolean;
	withTopBar?: boolean;
	modalType?: ModalTypeEnum;
	modalSize?: ModalSizeEnum;
	content?: JSX.Element;
	customSecondaryButton?: JSX.Element;
	primaryButtonText?: string;
	primaryButtonTestId?: string;
	secondaryButtonText?: string;
	secondaryButtonTestId?: string;
	primaryButtonDisabled?: boolean;
	isLoading?: boolean;
	onCloseIconClick?: () => void;
	onPrimaryButtonClick?: () => void;
	onSecondaryButtonClick?: () => void;
}
